import { Service } from "./Service";
import { PageBody as Body } from "../Entity/PageBody";
import type { HANavigationApp } from "../Entity/HANavigationApp";

export class PageBodyService extends Service {

    public reloadNav(nav: HANavigationApp): void {
        this.getBody().reloadNav(nav);
    }

    public showAppMenu(menuData: Array<Map<any, any>>): void {
        this.getBody().showAppMenu(menuData);
    }

    public getAppData(): Map<any, any> {
        // HA-203 — `ssr-app`/`ssr-nav` : payloads préchargés posés par le serveur
        // (PageService). Absents de cette liste, `hasPreload` restait faux dans
        // WebPage et le boot re-POSTait /ha/app en jetant le rendu embarqué.
        return this.getBody().getAttributes([
            "id", "_id", "_1", "app", "nav", "q", "r", "navigationId", "nonav", "controllerName",
            "controllerNamespace", "d", "_e", "_s", "_m", "attribute", "mainid", "noReload",
            "ssr-app", "ssr-nav",
        ]);
    }

    public getAppManager() {
        return this.getBody().getAppManager();
    }

    public showApp(app: any): void {
        const body = this.getBody();
        if (body) { body.showApp(app); }
    }

    protected getBody(): Body {
        return this.get("pageBody");
    }

    protected initialize(data?: any): void {
        super.initialize(data);
        this.addToData("pageBody", new Body(data));
    }
}
